const toastTypes = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

export default toastTypes;
